/* CarbonPhone – Produktvergleich: Auswahl, Tabelle, Empfehlung, Kategorie-Leiste */
(function () {
  if (window.CPCompare) return;
  var MAX = 4;
  var RANGE = 1.35; // Preisspanne fuer "Bestes Preis-Leistungs-Verhaeltnis"
  var fmt = function (c) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(c / 100);
  };
  var newer = function (a, b) { return b.year > a.year || (b.year === a.year && b.price < a.price) ? b : a; };

  /* Regel: neuestes Modell, das hoechstens 35 % teurer ist als das guenstigste. Gleichstand -> guenstiger. */
  function recommend(items) {
    if (items.length < 2) return null;
    var pool = items.filter(function (i) { return !i.basis; });
    if (!pool.length) pool = items;
    var cheapest = pool.reduce(function (a, b) { return b.price < a.price ? b : a; });
    var limit = cheapest.price * RANGE;
    var best = pool.filter(function (i) { return i.price <= limit; }).reduce(newer);
    var newest = pool.reduce(newer);
    var cheapestAll = items.reduce(function (a, b) { return b.price < a.price ? b : a; });
    if (best.price === cheapestAll.price) cheapestAll = best;
    var why;
    if (best === newest) {
      why = best === cheapest
        ? 'Das neueste Modell deiner Auswahl – und gleichzeitig das günstigste.'
        : 'Das neueste Modell deiner Auswahl (Marktstart ' + best.year + ')' + (best.price === cheapest.price ? ' – zum gleichen Preis wie das günstigste.' : ' und nur ' + fmt(best.price - cheapest.price) + ' teurer als das günstigste.');
    } else {
      why = 'Du sparst ' + fmt(newest.price - best.price) + ' gegenüber dem ' + newest.name + ' und bekommst ein Modell mit Marktstart ' + best.year +
        (best === cheapest ? ' – das günstigste deiner Auswahl.' : (best.price === cheapest.price ? ' – zum gleichen Preis wie das günstigste.' : ', nur ' + fmt(best.price - cheapest.price) + ' teurer als das günstigste.'));
    }
    return { best: best, cheapest: cheapestAll, newest: newest, why: why };
  }

  function readCols(root) {
    var map = {};
    root.querySelectorAll('thead th[data-h]').forEach(function (th) {
      map[th.dataset.h] = {
        h: th.dataset.h,
        name: th.dataset.name,
        url: th.dataset.url,
        price: parseInt(th.dataset.price, 10),
        year: parseInt(th.dataset.year, 10) || 0,
        basis: th.dataset.basis === 'true'
      };
    });
    return map;
  }

  /* Tabelle auf Auswahl einstellen (Reihenfolge + Sichtbarkeit) und Empfehlung berechnen */
  function render(root, sel) {
    var cols = readCols(root);
    sel = sel.filter(function (h) { return cols[h]; });
    root.querySelectorAll('.cp-cmp__table tr').forEach(function (tr) {
      var cells = {};
      tr.querySelectorAll('[data-h]').forEach(function (c) { cells[c.dataset.h] = c; c.hidden = sel.indexOf(c.dataset.h) === -1; });
      sel.forEach(function (h) { if (cells[h]) tr.appendChild(cells[h]); });
      Object.keys(cells).forEach(function (h) { if (sel.indexOf(h) === -1) tr.appendChild(cells[h]); });
    });
    var items = sel.map(function (h) { return cols[h]; });
    var r = recommend(items);
    root.querySelectorAll('[data-badges]').forEach(function (b) { b.innerHTML = ''; });
    root.querySelectorAll('td.is-best').forEach(function (td) { td.classList.remove('is-best'); });
    var box = root.querySelector('[data-reco]');
    if (r) {
      var add = function (h, cls, txt) {
        var b = root.querySelector('thead th[data-h="' + h + '"] [data-badges]');
        if (b) b.insertAdjacentHTML('beforeend', '<span class="cp-cmp__badge ' + cls + '">' + txt + '</span>');
      };
      add(r.best.h, 'cp-cmp__badge--best', 'Preis-Leistung');
      add(r.cheapest.h, 'cp-cmp__badge--cheap', 'Günstigstes');
      add(r.newest.h, 'cp-cmp__badge--new', 'Neuestes');
      root.querySelectorAll('td[data-h="' + r.best.h + '"]').forEach(function (td) { td.classList.add('is-best'); });
      if (box) {
        var a = box.querySelector('[data-reco-link]');
        a.textContent = r.best.name;
        a.href = r.best.url;
        box.querySelector('[data-reco-why]').textContent = r.why;
        var cta = box.querySelector('[data-reco-cta]');
        if (cta) cta.href = r.best.url;
        box.hidden = false;
      }
    } else if (box) {
      box.hidden = true;
    }
    var sc = root.querySelector('.cp-cmp__scroll'), sw = root.querySelector('[data-swipe]');
    if (sc && sw) sw.hidden = !(sc.scrollWidth > sc.clientWidth + 4);
    return sel;
  }

  /* ---------- Vergleichsseite ---------- */
  function initPage(root) {
    var boxes = [].slice.call(root.querySelectorAll('input[name="cp-m"]'));
    var known = boxes.map(function (b) { return b.value; });
    var btn = root.querySelector('[data-go]');
    var countEl = root.querySelector('[data-count]');
    var warn = root.querySelector('[data-warn]');
    var order = [];

    var params = new URLSearchParams(location.search);
    var start = (params.get('m') || '').split(',').map(function (s) { return s.trim(); }).filter(function (h) { return known.indexOf(h) > -1; });
    if (start.length < 2) {
      var def = (root.dataset.default || '').split(',').filter(function (h) { return known.indexOf(h) > -1 && start.indexOf(h) === -1; });
      start = start.concat(def);
      if (start.length < 2) start = start.concat(known.filter(function (h) { return start.indexOf(h) === -1; }));
    }
    order = start.slice(0, MAX);
    boxes.forEach(function (b) { b.checked = order.indexOf(b.value) > -1; });

    function sync() {
      countEl.textContent = order.length;
      btn.disabled = order.length < 2;
      boxes.forEach(function (b) { b.closest('label').setAttribute('aria-disabled', !b.checked && order.length >= MAX); });
    }
    boxes.forEach(function (b) {
      b.addEventListener('change', function () {
        if (b.checked) {
          if (order.length >= MAX) { b.checked = false; warn.hidden = false; setTimeout(function () { warn.hidden = true; }, 2600); return; }
          order.push(b.value);
        } else {
          order = order.filter(function (h) { return h !== b.value; });
        }
        sync();
      });
    });
    function apply(scroll) {
      render(root, order);
      var url = new URL(location.href);
      url.searchParams.set('m', order.join(','));
      history.replaceState(null, '', url);
      if (scroll) root.querySelector('.cp-cmp__result').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    btn.addEventListener('click', function () { apply(true); });
    var reset = root.querySelector('[data-reset]');
    if (reset) reset.addEventListener('click', function () { order = []; boxes.forEach(function (b) { b.checked = false; }); sync(); });

    // Marken-Filter
    var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
    var list = root.querySelector('.cp-cmp__opts');
    var more = root.querySelector('[data-more]');
    function filter(brand) {
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.tab === brand); });
      var n = 0;
      list.querySelectorAll('li').forEach(function (li) {
        var show = brand === 'all' || li.dataset.brand === brand;
        li.hidden = !show;
        if (show) { n++; li.classList.toggle('is-extra', n > 8); } else li.classList.remove('is-extra');
      });
      if (more) more.hidden = !(n > 8 && list.classList.contains('is-collapsed'));
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { filter(t.dataset.tab); }); });
    if (more) more.addEventListener('click', function () { list.classList.remove('is-collapsed'); more.hidden = true; });
    filter('all');

    sync();
    apply(false);
  }

  /* ---------- Produktseite ---------- */
  function initStatic(root) {
    var sel = [].slice.call(root.querySelectorAll('thead th[data-h]')).map(function (th) { return th.dataset.h; });
    render(root, sel);
  }

  /* ---------- Kategorie: Checkboxen + Leiste ---------- */
  function initBar(bar) {
    var data = {};
    try { data = JSON.parse(bar.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    var KEY = 'cp-compare-sel';
    var sel = [];
    try { sel = JSON.parse(sessionStorage.getItem(KEY) || '[]').filter(function (h) { return data[h]; }); } catch (e) {}
    var page = bar.dataset.page;

    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(sel)); } catch (e) {} }
    function update() {
      bar.classList.toggle('is-visible', sel.length > 0);
      bar.querySelector('[data-n]').textContent = sel.length === 1 ? '1 Modell ausgewählt' : sel.length + ' Modelle ausgewählt';
      bar.querySelector('[data-hint]').textContent = sel.length < 2 ? 'Wähle mindestens 2 Modelle' : (sel.length >= MAX ? 'Maximal ' + MAX + ' Modelle' : 'Bis zu ' + MAX + ' Modelle');
      bar.querySelector('[data-thumbs]').innerHTML = sel.map(function (h) { return '<span>' + (data[h].img ? '<img src="' + data[h].img + '" alt="" width="36" height="36" loading="lazy">' : '') + '</span>'; }).join('');
      var go = bar.querySelector('[data-go]');
      go.href = page + '?m=' + encodeURIComponent(sel.join(','));
      go.setAttribute('aria-disabled', sel.length < 2);
      document.querySelectorAll('.cp-cmp-chk input').forEach(function (i) { i.checked = sel.indexOf(i.value) > -1; });
    }
    function inject() {
      document.querySelectorAll('product-card[handle]').forEach(function (card) {
        var h = card.getAttribute('handle');
        if (!data[h] || card.querySelector('.cp-cmp-chk')) return;
        var info = card.querySelector('.product-card__info');
        if (!info) return;
        var l = document.createElement('label');
        l.className = 'cp-cmp-chk';
        l.innerHTML = '<input type="checkbox" value="' + h + '"> Vergleichen';
        l.querySelector('input').checked = sel.indexOf(h) > -1;
        l.querySelector('input').addEventListener('change', function (e) {
          if (e.target.checked) {
            if (sel.length >= MAX) { e.target.checked = false; bar.classList.add('is-visible'); bar.querySelector('[data-hint]').textContent = 'Maximal ' + MAX + ' Modelle – entferne zuerst eins'; return; }
            sel.push(h);
          } else sel = sel.filter(function (x) { return x !== h; });
          save(); update();
        });
        info.appendChild(l);
      });
    }
    bar.querySelector('[data-clear]').addEventListener('click', function () { sel = []; save(); update(); });
    inject(); update();
    new MutationObserver(function () { inject(); }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('[data-cp-cmp="page"]').forEach(initPage);
    document.querySelectorAll('[data-cp-cmp="static"]').forEach(initStatic);
    document.querySelectorAll('[data-cp-cmpbar]').forEach(initBar);
  }
  window.CPCompare = { recommend: recommend, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
